module.exports = __webpack_public_path__ + "img/index-photo.b97060d0.jpg";